import type { FunctionComponent } from 'react';
import React, { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import type { TestId } from '@trello/test-ids';

import type { RouterLinkProps } from './RouterLink';
import { RouterLinkComponent } from './RouterLink';

// Checks if the component is connected to redux store
// If it's connected then we can use RouterLink
// If it's not connected we can just use a regular link
export const LinkWrapper: FunctionComponent<RouterLinkProps> = ({
  children,
  href,
  ...props
}) => {
  let pathname: string;
  try {
    pathname = new URL(href || '').pathname;
  } catch (e) {
    pathname = href || '';
  }

  const reduxContext = useContext(ReactReduxContext);

  if (reduxContext && reduxContext.store) {
    return (
      <RouterLinkComponent href={pathname} {...props}>
        {children}
      </RouterLinkComponent>
    );
  }

  const expandedProps: RouterLinkProps & { 'data-testid'?: TestId } = {
    ...props,
  };
  expandedProps['data-testid'] = props.testId;
  delete expandedProps.testId;

  return (
    <a href={pathname} {...props}>
      {children}
    </a>
  );
};
